/** Cloudinary delivery tuned for solution accordion tab backgrounds. */
function getSolutionTabTransforms() {
  /* vc_h264 — Safari/iOS requires baseline H.264 in MP4. */
  const codec = 'f_mp4,vc_h264,q_auto:eco';
  if (typeof window === 'undefined') {
    return `${codec},w_960,c_limit`;
  }
  if (window.matchMedia('(max-width: 768px)').matches) {
    return `${codec},w_480,c_limit`;
  }
  if (window.matchMedia('(max-width: 1024px)').matches) {
    return `${codec},w_720,c_limit`;
  }
  return `${codec},w_960,c_limit`;
}

export function optimizeSolutionTabVideoUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('res.cloudinary.com') || !url.includes('/video/upload/')) {
    return url;
  }

  const transforms = getSolutionTabTransforms();

  const withVersion = url.replace(
    /\/video\/upload\/(?:[^/]+\/)*(?=v\d+\/)/,
    `/video/upload/${transforms}/`
  );
  if (withVersion !== url) return withVersion;

  return url.replace('/video/upload/', `/video/upload/${transforms}/`);
}
